import React, {Component} from 'react';
import {
  Stack,
} from '@shopify/polaris';
import toastAppBanner from'./../resources/toast_app_banner.jpg';
import check from'./../resources/check.svg';

class Upsell extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Stack alignment="center" distribution="center" spacing="extraLoose">
        <div className="app-container" onClick={() => { this.goTo('https://apps.shopify.com/toast-by-kiwisprout-non-intrusive-popups'); }}>
          <img src={toastAppBanner} className="app-banner" alt="Toast App Banner"/>
          <div className="app-bottom">
            <span className="app-perk"><img src={check} className="check-symbol" alt="checkmark"/>Boost sales with toast notifications.</span>
            <span className="app-perk"><img src={check} className="check-symbol" alt="checkmark"/>Capture the attention of visitors.</span>
            <span className="app-perk"><img src={check} className="check-symbol" alt="checkmark"/>Ready-to-use presets.</span>
          </div>
          <span className="app-cta">Click to learn more</span>
        </div>
      </Stack>
    );
  }

  // Open a URL in a new tab
  goTo = (url) => {
    window.open(url, '_blank');
  }
}

export default Upsell;
